import { withParams, ref } from 'vuelidate/lib/validators/common';

export var charactersSpecial = function charactersSpecial(otherProp) {
	return withParams({ type: otherProp }, function (value) {
		return !/[~.*+?^${}()!"·%/=/¿'´‚¨_\-,:ªº#¢@º¡`;çøñÑáéíóúàèìòùÁÉÍÓÚÀÈÌÒÙ|&]/.test(value);
	}
	// value => !/[^a-zA-Z_0-9Ññ\s]+$/g.test(value)
	);
};


//////////////////
// WEBPACK FOOTER
// ./src/validators/characters-special.js
// module id = ./src/validators/characters-special.js
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 12 14 15 16